module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-05.22fbf79f.png";